import React from "react";
import ShippingManagementBaseTable from "../BaseTable";
import { shippingExpress } from "@/apis/apis";

function MatrixExpressPage() {
  return (
    <ShippingManagementBaseTable
      apiURL={shippingExpress}
      label="Shipping Matrix Express"
    />
  );
}

export default MatrixExpressPage;
